import {colors} from "@c10h/colors";
import {useTranslation} from "@i18n/client";
import React, {useState} from "react";
import {ImageItem} from "src/constants/BiosConstants";
import {useV5ImgSrc} from "src/useV5ImgSrc";

import {LazyImg} from "../_common/LazyImg";

type Props = {
  imageList: ImageItem[];
};

const ImageFlipper: React.FC<Props> = ({imageList}) => {
  const i18n = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);

  const stagedIndex = activeIndex + 1 < imageList.length ? activeIndex + 1 : 0;

  const firstImage = imageList[activeIndex];
  // @ts-expect-error TS2345: Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
  const firstImageSrc = useV5ImgSrc(firstImage?.src);
  const stagedImage = imageList.length > 1 && imageList[stagedIndex];
  // @ts-expect-error TS2339: Property 'src' does not exist on type 'false | ImageItem'.
  const stagedImageSrc = useV5ImgSrc(stagedImage?.src || "");

  const showNextItem = () => setActiveIndex(stagedIndex);

  return (
    <div className="hfc minw24 minh120 pl6 pr6 pos-r">
      <div
        className="pos-r cp focus-bsDarkBlue3 h120 w100"
        style={{"--br": 1}}
        role="button"
        onClick={showNextItem}
        onKeyDown={e => e.key === "Enter" && showNextItem()}
        tabIndex={0}
        aria-label={i18n.t("View next photo")}
      >
        {firstImage && (
          <div className="pos-a-f zIndex1" style={{top: 0, left: 3}}>
            <LazyImg
              key={firstImage.src}
              src={firstImage.absSrc || firstImageSrc}
              aria-label={firstImage.alt}
              alt={firstImage.alt}
              className="bs1 br3 obfc h110 w90"
            />
          </div>
        )}
        {stagedImage && (
          <div className="pos-a zIndex0" style={{top: 20, right: 3}}>
            <LazyImg
              key={stagedImage.src}
              src={stagedImage.absSrc || stagedImageSrc}
              aria-label={stagedImage.alt}
              alt={stagedImage.alt}
              className="bs1 br3 h110 w90"
            />
          </div>
        )}
      </div>
      {stagedImage && (
        <div className="pos-a ma" style={{bottom: -20, left: 0, right: 0}}>
          {imageList.map((item, i) => (
            <span
              key={`circle-${item.src}`}
              className="br50 dib mr3 h3 w3 cp t-200"
              aria-label={i18n.t("View the image at this position in the stack")}
              onClick={() => {
                setActiveIndex(i);
              }}
              onKeyDown={e => {
                if (e.key === "Enter") {
                  setActiveIndex(i);
                }
              }}
              style={{
                backgroundColor: i === activeIndex ? colors.gray600 : colors.gray200,
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageFlipper;
